import type { CampaignPageQuery, CampaignPageQueryVariables } from 'src/types';
import campaignPage from '../query.graphql';
import { usePageQuery } from 'src/hooks/use-page-query';

export function useCampaignPageQuery(variables: CampaignPageQueryVariables) {
  return usePageQuery<CampaignPageQuery>({
    query: campaignPage,
    routeName: 'campaign',
    variables,
  });
}
